// extracted by mini-css-extract-plugin
export default {"happy-logo":"HappyLogo_happy-logo__-gGru"};